import { push } from 'connected-react-router';
import { get } from 'data/services/apiService';
import {
	// getHouseNumber,
	// getStreetName,
	// getBoroughNum,
	getAddressWithoutUSA,
} from 'utils/googlePlaceUtils';
import { fetchProperty } from 'reducers/propertyReducer';
import { API_URL } from 'data/services/apiConstants';

const POST_ADDRESS_REQUEST = 'POST_ADDRESS_REQUEST';
const POST_ADDRESS_SUCCESS = 'POST_ADDRESS_SUCCESS';
const POST_ADDRESS_ERROR = 'POST_ADDRESS_ERROR';

const initialState = {
	address: null,
	isLoading: false,
	error: null,
};

// function makeAwsRequest(
// 	dispatch,
// 	googlePlace,
// 	blockAndLot,
// 	inputAddress = '',
// 	onSelect = null
// ) {
// 	let awsBaseUrl =
// 		'https://itnqkr2qjj.execute-api.us-east-1.amazonaws.com/dev/overview';
// 	let url;
// 	let address;

// 	let latitude = null;
// 	let longitude = null;
// 	if (googlePlace) {
// 		// let houseNum = encodeURIComponent(getHouseNumber(googlePlace));
// 		// let streetName = encodeURIComponent(getStreetName(googlePlace));
// 		// let boroughNum = getBoroughNum(googlePlace);
// 		address = getAddressWithoutUSA(googlePlace, inputAddress);
// 		const addressParts = AddressHelper.extractAddressObject(
// 			googlePlace,
// 			inputAddress
// 		);

// 		latitude = googlePlace?.geometry?.location?.lat();
// 		longitude = googlePlace?.geometry?.location?.lng();
// 		url = `${awsBaseUrl}?house_number=${addressParts.houseNumber}&street=${addressParts.street}&borough=${addressParts.borough}`;
// 	} else if (blockAndLot) {
// 		url = `${awsBaseUrl}?block=${blockAndLot.block}&lot=${blockAndLot.lot}&borough=${blockAndLot.borough}`;
// 	} else {
// 		return dispatch(
// 			addressRequestError({
// 				message: 'Error: Google place or block, lot and borough are required',
// 			})
// 		);
// 	}

// 	return get({
// 		dispatch,
// 		url,
// 		onSuccess: (result) => {
// 			if (!result.hasOwnProperty('house_number')) {
// 				//this is when the aws process attempts to scrape a property that doesn't exist (or is outside nyc)
// 				if (!onSelect) {
// 					dispatch(push(`/property-not-found?address=${address}`));
// 				}

// 				if (onSelect) {
// 					onSelect(null);
// 				}

// 				return dispatch(
// 					addressRequestError({
// 						message: "Error: That property doesn't seem to exist",
// 					})
// 				);
// 			}
// 			const payload = { ...result, lat: latitude, long: longitude };
// 			dispatch(addressRequestSuccess());
// 			return dispatch(postNewProperty(payload, address, onSelect));
// 		},
// 		onError: (error) => {
// 			dispatch(addressRequestError(error));
// 			dispatch(push(`/property-not-found?address=${address}`));
// 		},
// 	});
// }

// commented makeAwsRequest - backend now handles GOAT/Lambda fallback internally
// Frontend just needs to call the backend API with the address

export const checkAddressAsString = (address) => (dispatch) => {
	dispatch(addressRequest(address));

	// Single call to backend - backend handles DB check, GOAT, and Lambda fallback
	return dispatch(fetchProperty(address));
};

export const checkAddressByGooglePlace =
	(googlePlace, inputAddress = '', onSelect = null) =>
		(dispatch) => {
			let addressWithoutUSA = getAddressWithoutUSA(googlePlace, inputAddress);

			dispatch(addressRequest(addressWithoutUSA));

			// Single call to backend - backend handles DB check, GOAT, and Lambda fallback
			return dispatch(fetchProperty(addressWithoutUSA, onSelect));
		};

export const checkAddressByGooglePlaceForModal =
	(googlePlace, inputAddress = '', onSelect = null) =>
		(dispatch) => {
			let addressWithoutUSA = getAddressWithoutUSA(googlePlace, inputAddress);

			// Single call to backend - backend handles DB check, GOAT, and Lambda fallback
			return dispatch(fetchProperty(addressWithoutUSA, onSelect));
		};

export const checkBlockAndLot =
	({ block, lot, borough }) =>
		(dispatch, getState) => {
			let state = getState();
			let userId = state.user.id || null;

			let url = `${API_URL}/api/check/property/blockandlot?block=${block}&lot=${lot}&user_id=${userId}`;

			dispatch(addressRequest(null)); //todo: handle block and lot or just get rid of address prop

			return get({
				dispatch,
				url,
				onSuccess: (result) => {
					if (result && result.address) {
						dispatch(addressRequestSuccess());
						return dispatch(fetchProperty(result.address));
					} else {
						// Property not found - backend will handle creation via GOAT/Lambda
						dispatch(addressRequestError({
							message: "Error: Property not found and could not be created",
						}));
						dispatch(push(`/property-not-found`));
					}
				},
				onError: (error) => {
					// return makeAwsRequest(dispatch, null, { block, lot, borough });
					dispatch(addressRequestError(error));
					dispatch(push(`/property-not-found`));
				},
			});
		};

export const checkByBin = (bin) => (dispatch, getState) => {
	let state = getState();
	let userId = state.user.id || null;

	let url = `${API_URL}/api/check/property/by-identifiers?bin=${bin}&user_id=${userId}`;

	dispatch(addressRequest(null));

	return get({
		dispatch,
		url,
		onSuccess: (result) => {
			if (result && result.address) {
				dispatch(addressRequestSuccess());
				return dispatch(fetchProperty(result.address));
			} else {
				dispatch(
					addressRequestError({
						message: "Error: We couldn't find that property by BIN",
					})
				);
			}
		},
		onError: (error) => {
			dispatch(addressRequestError(error));
		},
	});
};

export const addressRequest = (address) => ({
	type: POST_ADDRESS_REQUEST,
	payload: {
		address,
		isLoading: true,
	},
});

export const addressRequestSuccess = () => ({
	type: POST_ADDRESS_SUCCESS,
	payload: {
		isLoading: false,
		error: null,
	},
});

export const addressRequestError = (error) => ({
	type: POST_ADDRESS_ERROR,
	payload: {
		isLoading: false,
		error: error,
	},
});

const addressReducer = (state = initialState, action) => {
	switch (action.type) {
		case POST_ADDRESS_REQUEST:
		case POST_ADDRESS_SUCCESS:
		case POST_ADDRESS_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default addressReducer;
